import * as React from 'react';

const CentredLoader: React.FC = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: ' 100%' }}>
    Loading...
  </div>
);

export default CentredLoader;
